window.loadedScripts = 1;
import polyfills from '@core/polyfills';
import hamburger from './hamburger';
import scrollIt from './scrollToAnchor';
import cookieconsent from 'cookieconsent';
import overlay from './overlay';
import lazyLoad from './lazyLoad';
import hero from './hero'
import forms from './forms'
import { Video } from '@core/video';
import datepicker from './datepicker';
import focal from './focal';

new Video([...document.querySelectorAll('[data-video]')]);

// toggle lang navigation
let langEl = document.querySelector('.languages');
if ( langEl ) {
    langEl.addEventListener('click', (e) => {
        e.stopPropagation();
        langEl.classList.toggle('active');
    });

    document.addEventListener('click', function (e) {
        langEl.classList.remove('active');
    });
}

// Scroll to
const btns = document.querySelectorAll('a[href*="#"]:not([href="#"])');
if ( btns ) {
    btns.forEach( (el) => {
        el.addEventListener('click', () => {
            if (el.getAttribute('data-toggle')) {
                return ;
            }
            console.log('Clicked');
            let hrefEl = el.getAttribute('href');
            let idEl = document.querySelector(`${hrefEl}`);
            scrollIt(idEl, 800, 'easeOutCubic');
        });
    });
}


// WEBPACK FOOTER //
// ./themes/wild/assets/js/main.js